export default {
      id: "home-usage",
      viewBox: "0 0 30 33",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#home",
      toString: function () {
        return this.url;
      }
    }